// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"28d499c9","805":"b34529ab","941":"8965a6ec"}[chunkId] + ".chunk.css";
};